import React, { memo, useEffect } from 'react'
import { StatusPane } from '@pff-consumer/tweed-ui/molecules/status-pane/status-pane.web'
import { CurrentProgressState } from '@pff-consumer/schema'
import { useSubscribeAnalyticsEvent } from '@pff-consumer/analytics/hooks/useSubscribeAnalyticsEvent'
import { useRouter } from 'next/router'
import { useRedirectTo } from '../../hooks/useRedirectTo'
import { useStyles } from './create-account-success.styles'

export const CreateAccountSuccess = memo(() => {
  const styles = useStyles()
  const router = useRouter()
  const { sendSubscribeAnalyticsEvent } = useSubscribeAnalyticsEvent()

  const onRouterReady = (redirectToParam: string) => {
    router.push({ query: { success: true, redirect_to: redirectToParam } }, undefined, { shallow: true })
  }

  useRedirectTo({ router, onReady: onRouterReady })

  useEffect(() => {
    sendSubscribeAnalyticsEvent('Account Created', {
      // TODO Need to pass accountMethod appropriately when social sign-in are implemented
      accountMethod: 'Email',
      subscriptionType: 'Free',
      source: 'Subscribe',
    })
  }, [])

  return (
    <div className={styles.createAccountContainer}>
      <StatusPane
        state={CurrentProgressState.SUCCESS}
        header='Success! Account Created'
        message=''
      />
    </div>
  )
})
